import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { formatMoney, formatMoney_2 } from '../../../../helpers/DateFormat';

const PayrollTableListView = () => {
    const {PayrollList} = useSelector((state:RootState)=>state.payroll);
    const payrollData = Array.isArray(PayrollList?.data) ? PayrollList.data : [];
    return (
        <Fragment>
            <div className='bg-white dark:bg-slate800 shodow rounded-md p-3'>
                <div className="relative w-full overflow-x-auto">
                    <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-gray-700 dark:text-gray-400">
                        <thead className="text-[12px] font-public-sans px-6 text-slate800 capitalize border-b dark:bg-slate700 bg-slate-200 dark:text-slate-100 dark:border-gray-700">
                            <tr>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700 w-10">
                                    S.N.
                                </th>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Emp Name
                                </th>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Designation
                                </th>
                                <th scope="col" colSpan={3} align='center' className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Salary
                                </th>
                                <th scope="col" colSpan={2} align='center' className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Thap Amount
                                </th>
                                <th scope="col" rowSpan={3} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Su Thap Salary
                                </th>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Total Salary
                                </th>
                                <th scope="col" colSpan={4} align='center' className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Katti Amount
                                </th>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Thap Sa.
                                </th>
                                <th scope="col" rowSpan={2} className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Total Salary
                                </th>

                            </tr>
                            <tr>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Initial Salary
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Grade
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Total
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Thap
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Other
                                </th>


                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Tax
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Sa. Su.
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Other
                                </th>
                                <th scope="col" className="px-3 py-0.5 border border-gray-300 dark:border-gray-700">
                                    Holiday Amount
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            {
                                payrollData.map((emp: any, index: any) => (
                                    <tr key={index} className="bg-white text-[11px] font-public-sans dark:bg-slate800 hover:cursor-pointer text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600">
                                        <td align='center' className="px-3 py-0.5 border dark:border-gray-700">
                                            {index + 1}.
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-700 dark:border-gray-700 font-medium">
                                            {emp?.mem_name}
                                        </td>

                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {emp?.designation_name}
                                        </td>

                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.basic_sal ||0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.grade_amount || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.basic_tot_amount ||0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.thap || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.other_ai || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.tot_salary || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.tot_salary || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.tax || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.sa_su_tax || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.OtherLessAmt || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.abs_amt || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border text-slate-500 dark:border-gray-700">
                                            {formatMoney_2(emp?.abs_amt || 0)}
                                        </td>
                                        <td className="px-3 py-0.5 border dark:border-gray-700">
                                            {formatMoney(emp?.net_salary || "0")}
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>

                </div>

            </div>
        </Fragment>
    )
}

export default PayrollTableListView